// removed by extract-text-webpack-plugin
module.exports = {"usersList__list":"usersList__list___NVMrJ","usersList":"usersList___KGp9p","usersList__item":"usersList__item___1mQIE","usersList__itemStaff":"usersList__itemStaff___j69v0","user":"user___llQBd","user__name":"user__name___2Re3G","user__email":"user__email___3BJiq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/UsersManagement/styles.module.scss
// module id = 468
// module chunks = 0